import styled from 'styled-components'

export const Wrapper = styled.div`
  padding: 15px;
  flex: 1;
  border: 1px solid #ccc;
  border-radius: 4px;
`

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 0.9rem;

  &:nth-child(even) {
    background-color: #d6e5f2;
  }

  &:not(:first-child) {
    padding: 4px 7px;
  }
`

export const Name = styled.div`
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  font-weight: bold;
  color: rgb(0, 102, 153);
`

export const Icon = styled.em`
  margin-right: 8px;
  font-size: 1.4rem;
`

export const InfoLeft = styled.div`
  font-weight: bold;
`

export const InfoRight = styled.div``

export const Inputs = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const InputWrapper = styled.div`
  width: 100%;
  margin-top:10px;
`